import { render, staticRenderFns } from "./deleteBtn.vue?vue&type=template&id=0f84dd7a&scoped=true&"
import script from "./deleteBtn.vue?vue&type=script&lang=js&"
export * from "./deleteBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f84dd7a",
  null
  
)

export default component.exports